'use strict';
define([
    'angular',
    'modules/leadgeneration/pricing/pricing.controller',
],function(angular, LeadGenerationFormAnalyticsLeadsPricingCtrl){
    var app=angular.module('app.leadgeneration.pricing', []);
    app.controller('LeadGenerationFormAnalyticsLeadsPricingCtrl',LeadGenerationFormAnalyticsLeadsPricingCtrl);
    return app;
});